import { NavLink, useNavigate, Link } from "react-router-dom";
import {
  SquaresFour, Package, Users, Gear, ClipboardText, SignOut, ListChecks,
} from "@phosphor-icons/react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import { List, X } from "@phosphor-icons/react";

const items = [
  { to: "/admin", label: "Dashboard", icon: SquaresFour, end: true },
  { to: "/admin/orders", label: "Orders", icon: Package },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: Gear },
  { to: "/admin/audit", label: "Audit Log", icon: ClipboardText },
];

export default function AdminLayout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const nav = (
    <nav className="flex flex-col gap-1 p-3">
      {items.map((it) => (
        <NavLink
          key={it.to}
          to={it.to}
          end={it.end}
          onClick={() => setOpen(false)}
          data-testid={`admin-nav-${it.label.toLowerCase().replace(/\s+/g, "-")}`}
          className={({ isActive }) =>
            `flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium transition-colors ${
              isActive ? "bg-[#0A4F35] text-white" : "text-emerald-50/80 hover:bg-white/10"
            }`
          }
        >
          <it.icon size={20} />
          {it.label}
        </NavLink>
      ))}
    </nav>
  );

  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      {/* mobile top bar */}
      <div className="lg:hidden flex items-center justify-between bg-[#083D29] px-4 py-3 text-white">
        <Logo variant="text" to="/admin" />
        <button onClick={() => setOpen((v) => !v)} data-testid="admin-mobile-toggle">
          {open ? <X size={26} /> : <List size={26} />}
        </button>
      </div>
      <div className="flex">
        <aside className={`fixed inset-y-0 left-0 z-40 w-64 bg-[#083D29] flex-col ${open ? "flex" : "hidden"} lg:flex lg:static`}>
          <div className="hidden lg:flex items-center h-16 px-5 border-b border-white/10">
            <Logo variant="text" to="/admin" />
          </div>
          <div className="flex-1 overflow-y-auto">{nav}</div>
          <div className="border-t border-white/10 p-3">
            <div className="px-3 py-2 text-xs text-emerald-100/70">{user?.email}</div>
            <button
              data-testid="admin-logout-btn"
              onClick={async () => { await logout(); navigate("/login"); }}
              className="flex w-full items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-emerald-50/80 hover:bg-white/10"
            >
              <SignOut size={20} /> Sign out
            </button>
          </div>
        </aside>
        {open && <div className="fixed inset-0 z-30 bg-black/40 lg:hidden" onClick={() => setOpen(false)} />}
        <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">{children}</main>
      </div>
    </div>
  );
}
